import Icon from '../components/Icon';

const Weather9 = Icon(
  'weather-9',
  <>
    <path
      fillRule="evenodd"
      d="M4.067 7.27c.583-3.417 3.549-6.02 7.125-6.02a7.22 7.22 0 0 1 6.063 3.302C20.3 4.6 22.75 7.09 22.75 10.15c0 3.09-2.498 5.599-5.584 5.599h-5.052l-1.454 2.69a.75.75 0 1 1-1.32-.713l1.069-1.977H5.62a4.377 4.377 0 0 1-4.371-4.383 4.38 4.38 0 0 1 2.817-4.098m13.1 6.98H5.62a2.877 2.877 0 0 1-2.871-2.883c0-1.353.928-2.487 2.177-2.799a.75.75 0 0 0 .565-.653c.292-2.902 2.734-5.165 5.7-5.165 2.141 0 4.01 1.18 4.993 2.93a.75.75 0 0 0 .704.38q.138-.009.277-.009a4.09 4.09 0 0 1 4.084 4.1c0 2.266-1.83 4.099-4.084 4.099"
      clipRule="evenodd"
    />
    <path d="M14.327 18.357a.75.75 0 0 0-1.32-.714l-1.667 3.084a.75.75 0 0 0 1.32.713z" />
  </>
);

export default Weather9;
